import { render, staticRenderFns } from "./LabelGroup.vue?vue&type=template&id=58d3ea29"
import script from "./LabelGroup.vue?vue&type=script&lang=js"
export * from "./LabelGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports